import { useState } from "react";
import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";
import axios from "axios";
import FullScreenLoader from "../../../FullScreenLoader/FullScreenLoader";

const inputStyle = {
  width: "100%",
  fontSize: "14px",
  height: "40px",
  padding: "0 10px",
  boxSizing: "border-box",
};

const labelStyle = {
  fontSize: "11px",
  fontWeight: "bold",
  marginBottom: "3px",
  display: "block",
};

const emptyForm = {
  tip_pregleda: "PRETHODNI",
  datum_pregleda: "",
  interval_meseci: 12,
  datum_sledeci: "",
  broj_izvestaja: "",
  ocena: "SPOSOBAN",
  mere: "",
};

function LekarskiIzvestajForm({
  fileNewDocument,
  generalData,
  setGeneralData,
}) {
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);
  const { baseUrl, selectedMainEntity } = useGlobalContext();

 const onChange = (key, value) => {
  setForm((prev) => {
    const updated = { ...prev, [key]: value };
    if (key === "datum_pregleda" || key === "interval_meseci") {
      const dp = key === "datum_pregleda" ? value : prev.datum_pregleda;
      const im =
        key === "interval_meseci"
          ? Number(value)
          : Number(prev.interval_meseci);
      if (dp && im) {
        const d = new Date(dp);
        d.setMonth(d.getMonth() + im);
        if (!isNaN(d.getTime())) {                          // ← add this
          updated.datum_sledeci = d.toISOString().split("T")[0];
        }
      }
    }
    return updated;
  });
};

  const handleSacuvaj = async (archiveOldId = null) => {
    // Provera koja radi bez obzira da li je ID broj ili string
    if (!generalData.zaposlen || String(generalData.zaposlen.id) === "-1") {
      alert("Odaberi zaposlenog.");
      return;
    }

    if (!form.datum_pregleda) {
      alert("Unesi datum pregleda.");
      return;
    }

    setLoading(true);
    try {
      // 1. Sačuvaj dokument zaposlenog
      const formData = new FormData();
      formData.append("employee_id", generalData.zaposlen.id);
      formData.append("vrsta", "ЛЕКАРСКИ ИЗВЕШТАЈ"); // Dodajemo 'vrsta' jer PHP to traži
      formData.append("naziv", "ЛЕКАРСКИ ИЗВЕШТАЈ");
      formData.append("datum_isteka", form.datum_sledeci || "");
      formData.append("is_scan", "1");

      if (archiveOldId) formData.append("archive_old_id", archiveOldId);
      if (fileNewDocument) formData.append("file", fileNewDocument);

      const { data: docRes } = await axios.post(
        `${baseUrl}/zaposleni/create_document.php`,
        formData,
      );

      // Logika za arhiviranje ako dokument već postoji
      if (docRes.status === 409 && docRes.needs_confirm) {
        if (window.confirm(docRes.message)) {
          setLoading(false);
          handleSacuvaj(docRes.old_id);
          return;
        } else {
          setLoading(false);
          return;
        }
      }

      if (docRes.status !== 200) {
        alert(docRes.message || "Greška pri čuvanju dokumenta.");
        setLoading(false);
        return;
      }

      // 2. Upiši u evidencija_obrazac1
      const ev1Res = await axios.post(`${baseUrl}/evidencija1/create.php`, {
        company_id: selectedMainEntity.company_id,
        workplace_id:
          generalData.radnoMesto.id != -1 ? generalData.radnoMesto.id : null,
        employee_id: generalData.zaposlen.id,
        tip_pregleda: form.tip_pregleda,
        datum_pregleda: form.datum_pregleda || null,
        datum_sledeci: form.datum_sledeci || null,
        interval_meseci: Number(form.interval_meseci),
        broj_izvestaja: form.broj_izvestaja || null,
        ocena: form.ocena,
        mere: form.mere || null,
      });

      if (ev1Res.data.status === 200) {
        setForm(emptyForm);
        // Resetujemo globalno stanje da ispraznimo formu
        setGeneralData({
          radnoMesto: { id: -1, name: "" },
          zaposlen: { id: -1, name: "" },
          vrsta: { id: -1, name: "" },
          naziv: "",
          brojDokumenta: "",
          vaziDo: "",
          isScan: false,
        });
        alert("Лекарски извештај сачуван.");
        window.dispatchEvent(new CustomEvent("documentAdded"));
      } else {
        alert("Dokument sačuvan, ali greška pri upisu u evidenciju.");
      }
    } catch (e) {
      console.error(e);
      alert("Greška na serveru.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <FullScreenLoader />;

  return (
    <div
      style={{
        flexBasis: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        marginTop: "10px",
        padding: "14px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        background: "#fafafa",
      }}
    >
      {/* Red 1 */}
      <div style={{ display: "flex", gap: "14px", flexWrap: "wrap" }}>
        <div style={{ minWidth: "180px" }}>
          <label style={labelStyle}>ТИП ПРЕГЛЕДА *</label>
          <select
            value={form.tip_pregleda}
            onChange={(e) => onChange("tip_pregleda", e.target.value)}
            style={{ ...inputStyle }}
          >
            <option value="PRETHODNI">ПРЕТХОДНИ</option>
            <option value="PERIODICNI">ПЕРИОДИЧНИ</option>
          </select>
        </div>

        <div style={{ minWidth: "160px" }}>
          <label style={labelStyle}>ДАТУМ ПРЕГЛЕДА *</label>
          <input
            type="date"
            value={form.datum_pregleda}
            onChange={(e) => onChange("datum_pregleda", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div style={{ minWidth: "120px" }}>
          <label style={labelStyle}>ИНТЕРВАЛ (месеци)</label>
          <input
            type="number"
            min={1}
            max={60}
            value={form.interval_meseci}
            onChange={(e) => onChange("interval_meseci", e.target.value)}
            style={{ ...inputStyle, width: "100px" }}
          />
        </div>

        <div style={{ minWidth: "160px" }}>
          <label style={labelStyle}>СЛЕДЕЋИ ПРЕГЛЕД</label>
          <input
            type="date"
            value={form.datum_sledeci}
            onChange={(e) => onChange("datum_sledeci", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div style={{ minWidth: "160px" }}>
          <label style={labelStyle}>БРОЈ ИЗВЕШТАЈА</label>
          <input
            type="text"
            value={form.broj_izvestaja}
            onChange={(e) => onChange("broj_izvestaja", e.target.value)}
            style={inputStyle}
          />
        </div>

        <div style={{ minWidth: "180px" }}>
          <label style={labelStyle}>ОЦЕНА</label>
          <select
            value={form.ocena}
            onChange={(e) => onChange("ocena", e.target.value)}
            style={inputStyle}
          >
            <option value="SPOSOBAN">СПОСОБАН</option>
            <option value="NIJE SPOSOBAN">НИЈЕ СПОСОБАН</option>
          </select>
        </div>
      </div>

      {/* Mere */}
      <div>
        <label style={labelStyle}>
          Предузете мере (распоређен на друго радно место - послове)
        </label>
        <textarea
          value={form.mere}
          onChange={(e) => onChange("mere", e.target.value)}
          rows={3}
          style={{
            ...inputStyle,
            height: "auto",
            padding: "8px 10px",
            resize: "vertical",
          }}
          placeholder="Предузете мере (распоређен на друго радно место - послове)"
        />
      </div>

      {/* Dugmad */}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <div
          onClick={() => {
            setForm(emptyForm);
            setGeneralData((prev) => ({
              ...prev,
              vrsta: { id: -1, name: "" },
            }));
          }}
        >
          <Button
            activation={true}
            style={{ padding: "5px 30px", fontWeight: "bold" }}
          >
            ОДУСТАНИ
          </Button>
        </div>
        <div
          onClick={!loading ? handleSacuvaj : undefined}
          style={{ opacity: loading ? 0.5 : 1 }}
        >
          <Button
            activation={true}
            style={{ padding: "5px 30px", fontWeight: "bold" }}
          >
            {loading ? "..." : "САЧУВАЈ"}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default LekarskiIzvestajForm;
